import { largeTabletMax } from '@propertypal/shared/src/constants/mediaQueries';
import Link from 'next/link';
import styled from 'styled-components';

export const Container = styled.nav`
  display: none;
  width: 100vw;
  flex-direction: row;
  align-items: center;
  position: fixed;
  z-index: 20;
  bottom: 0;
  background: ${(props) => props.theme.background};
  border-top: 1px solid ${(props) => props.theme.backgroundLight};
  border-collapse: collapse;
  padding-bottom: 10px;

  @media screen and (${largeTabletMax}) {
    display: flex;
  }
`;

export const Links = styled.ul`
  margin: 0;
  padding: 0;
  display: flex;
  width: 100%;
  flex-direction: row;
  list-style: none;
  flex: 1;
  justify-content: center;
  height: 60px;
`;

export const Item = styled.li`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;

  .itemShortTitle {
    display: none;
  }

  @media (max-width: 600px) {
    .itemTitle {
      display: none;
    }
    .itemShortTitle {
      display: block;
    }
  }
`;

export const Icon = styled.img<{ active: boolean }>`
  display: block;
  margin: 4px auto;
  color: ${(props) => props.theme.backgroundMid};

  ${(props) =>
    props.active &&
    `
    filter: invert(39%) sepia(72%) saturate(4668%) hue-rotate(4deg) brightness(96%) contrast(101%);
  `}
`;

export const CustomButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  display: inline-block;
  flex: 1;
  font: inherit;
`;

export const CustomMenuButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  width: 100%;
  // font: inherit;
`;

export const MoreMenu = styled.ul`
  height: calc(100% - 71px);
  width: 100%;
  position: fixed;
  flex-direction: column;
  list-style: none;
  padding: 0;
  top: 0;
  left: 0;
  background: ${(props) => props.theme.white};
  -webkit-overflow-scrolling: touch;
  overflow-y: scroll;
`;

export const LinkBox = styled(Link)<{ active?: boolean }>`
  padding: 16px;
  cursor: pointer;
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 63px;
  border-bottom: 1px solid ${(props) => props.theme.lightGrey};

  &:hover p {
    color: ${(props) => props.theme.primary};
  }
`;

export const Plus = styled.div``;

export const OptionBox = styled.div<{ active?: boolean }>`
  padding: 16px;
  cursor: pointer;
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 63px;
  border-bottom: 1px solid ${(props) => props.theme.lightGrey};

  &:hover p {
    color: ${(props) => props.theme.primary};
  }
`;

export const SubmenuOptions = styled.ul<{ show: boolean }>`
  display: flex;
  flex-direction: column;
  list-style: none;
  overflow: hidden;
  padding: 0;
  max-height: ${(props) => (props.show ? '500px' : 0)};
  transition: max-height 0.5s ease-out;
`;

export const SubLinkBox = styled(Link)`
  padding: 20px;
  cursor: pointer;
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 49px;

  &:hover p {
    color: ${(props) => props.theme.primary};
  }

  &:first-child {
    padding-top: 40px;
  }

  &:last-child {
    padding-bottom: 40px;
  }
`;

export const MenuIcon = styled.div`
  transition: all 1s;
`;
